import * as React from 'react';
import { append, includes, path, without } from 'ramda';

import { IBaseQuestionProps } from '../../FormContainer/types/internal';

export const useHandleSelect = (params: IBaseQuestionProps) => {
  const {
    question: { answerField },
    setAnswersState,
  } = params;

  return React.useCallback(
    (value: string) => {
      setAnswersState(prevState => {
        const formValue: string[] = path([answerField, 'value'], prevState) || [];
        const newValue = includes(value, formValue) ? without([value], formValue) : append(value, formValue);
        const answer = {
          answerField,
          value: newValue,
        };

        return {
          ...prevState,
          [answerField]: answer,
        };
      });
    },
    [answerField, setAnswersState],
  );
};
